import React from 'react';

class ApplicantOwnership extends React.Component {
  applicantDisplay = (applicant, idx) => {
    const first = applicant.given_name || '';
    const last = applicant.family_name || '';
    const full = `${first} ${last}`.trim();
    return full || `Applicant ${idx + 1}`;
  };

  toggle = (applicantId) => {
    const { value, onChange } = this.props;
    const safe = { ...(value || {}) };
    safe[applicantId] = !safe[applicantId];
    onChange(safe);
  };

  render() {
    const { applicants, value, label, required, fieldId, error } = this.props;
    const hasError = !!error;
    return (
      <div data-field-id={fieldId || undefined}>
        <label className="block text-sm font-medium text-[#1F2937] mb-2">
          {label || 'Owned by'}
          {required ? <span className="text-[#DC2626] ml-1">*</span> : null}
        </label>
        <div
          className="flex flex-wrap gap-2"
          style={
            hasError
              ? {
                  padding: '6px',
                  margin: '-6px',
                  borderRadius: '14px',
                  boxShadow: '0 0 0 1px #DC2626',
                }
              : undefined
          }
        >
          {applicants.map((a, idx) => {
            const checked = !!(value && value[a.id]);
            return (
              <button
                key={a.id}
                type="button"
                onClick={() => this.toggle(a.id)}
                className="inline-flex items-center gap-2 rounded-full border-2 px-3 py-1.5 text-xs font-medium"
                style={{
                  borderColor: checked ? '#7C5CFC' : '#D1D5DB',
                  backgroundColor: checked ? '#EFEAFE' : '#FFFFFF',
                  color: checked ? '#5B3FE0' : '#1F2937',
                }}
              >
                <span
                  className="inline-flex items-center justify-center h-4 w-4 rounded border"
                  style={{
                    borderColor: checked ? '#7C5CFC' : '#9CA3AF',
                    backgroundColor: checked ? '#7C5CFC' : '#FFFFFF',
                  }}
                >
                  {checked ? (
                    <svg className="h-3 w-3 text-white" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M16.7 5.3a1 1 0 010 1.4l-7.5 7.5a1 1 0 01-1.4 0L3.3 9.7a1 1 0 011.4-1.4l3.8 3.8 6.8-6.8a1 1 0 011.4 0z" clipRule="evenodd" />
                    </svg>
                  ) : null}
                </span>
                {this.applicantDisplay(a, idx)}
              </button>
            );
          })}
        </div>
        {hasError ? (
          <p className="mt-1 text-xs font-medium text-[#DC2626]">{error}</p>
        ) : null}
      </div>
    );
  }
}

export default ApplicantOwnership;
